export default __webpack_public_path__ + "static/media/user.21297d12.png";